module.exports = __webpack_public_path__ + "img/feedback.8a5f2c8d.png";